/**
 * Mock Data: Reward Catalog
 * Static dataset for reward catalog UI layout.
 */

import type { PaginatedApiResponse } from "@/remote/api";
import type { VoucherListItemDto, VoucherDetailDto } from "../data/remote/response";

/**
 * Mock voucher list data matching API response structure
 */
export const mockVoucherListData: PaginatedApiResponse<VoucherListItemDto> = {
  data: [
    {
      voucherId: "VOU-202512-001",
      title: "Travel Bag Up To 60% OFF For All Size",
      brandName: "American Tourister",
      categoryId: "CAT-001",
      categoryName: "Travel Accessories",
      pointsRequired: 25450,
      remainingStock: 156,
      totalStock: 1000,
      totalRedeemed: 844,
      status: "active",
      isPopular: true,
      badgeText: "N",
      badgeColor: "#0066FF",
      validFrom: "2025-01-01T00:00:00.000Z",
      validUntil: "2025-12-31T23:59:59.999Z",
      createdAt: "2024-12-01T12:00:00.000Z",
      updatedAt: "2025-01-15T10:30:00.000Z",
      createdBy: "admin@swarapoint.com",
    },
    {
      voucherId: "VOU-202512-002",
      title: "Diskon 70% Sneakers Nike Air Max",
      brandName: "Nike",
      categoryId: "CAT-002",
      categoryName: "Footwear",
      pointsRequired: 35000,
      remainingStock: 320,
      totalStock: 500,
      totalRedeemed: 180,
      status: "active",
      isPopular: true,
      badgeText: "HOT",
      badgeColor: "#FF0000",
      validFrom: "2025-02-01T00:00:00.000Z",
      validUntil: "2025-06-30T23:59:59.999Z",
      createdAt: "2025-01-10T09:00:00.000Z",
      updatedAt: "2025-02-05T14:20:00.000Z",
      createdBy: "admin@swarapoint.com",
    },
    {
      voucherId: "VOU-202512-003",
      title: "Buy 1 Get 1 Free Coffee",
      brandName: "Starbucks",
      categoryId: "CAT-003",
      categoryName: "Food & Beverage",
      pointsRequired: 15000,
      remainingStock: 500,
      totalStock: 750,
      totalRedeemed: 250,
      status: "active",
      isPopular: false,
      badgeText: "",
      badgeColor: "",
      validFrom: "2025-01-15T00:00:00.000Z",
      validUntil: "2025-03-31T23:59:59.999Z",
      createdAt: "2025-01-01T08:00:00.000Z",
      updatedAt: "2025-01-20T11:45:00.000Z",
      createdBy: "partner@starbucks.com",
    },
    {
      voucherId: "VOU-202512-004",
      title: "Discount 30% All Menu",
      brandName: "KFC",
      categoryId: "CAT-003",
      categoryName: "Food & Beverage",
      pointsRequired: 12000,
      remainingStock: 0,
      totalStock: 1000,
      totalRedeemed: 1000,
      status: "inactive",
      isPopular: false,
      badgeText: "SOLD",
      badgeColor: "#999999",
      validFrom: "2024-11-01T00:00:00.000Z",
      validUntil: "2024-12-31T23:59:59.999Z",
      createdAt: "2024-10-15T10:00:00.000Z",
      updatedAt: "2024-12-31T23:59:59.999Z",
      createdBy: "admin@swarapoint.com",
    },
  ],
  paging: {
    currentPage: 1,
    pageSize: 10,
    totalRecords: 4,
    totalPages: 1,
  },
};

/**
 * Mock voucher detail data matching API response structure
 */
export const mockVoucherDetailData: VoucherDetailDto = {
  voucherId: "VOU-202512-001",
  title: "Travel Bag Up To 60% OFF For All Size",
  description: "Get amazing discount on all American Tourister travel bags.",
  categoryId: "CAT-001",
  categoryName: "Travel Accessories",
  brandId: "american-tourister",
  brandName: "American Tourister",
  merchantId: "merchant-001",
  merchantName: "Official Store",
  pointsRequired: 25450,
  totalStock: 1000,
  remainingStock: 156,
  totalRedeemed: 844,
  status: "active",
  isPopular: true,
  badgeText: "N",
  badgeColor: "#0066FF",
  imageUrls: [
    "https://example.com/images/voucher1.jpg",
    "https://example.com/images/voucher2.jpg",
  ],
  termsAndConditions: [
    "Valid for one-time use only",
    "Cannot be combined with other promotions",
    "Valid at participating stores only",
  ],
  howToUse: [
    "Show this voucher at checkout",
    "Present your membership card",
    "Discount will be applied automatically",
  ],
  applicableStoreIds: ["store-001", "store-002", "store-003"],
  validFrom: "2025-01-01T00:00:00.000Z",
  validUntil: "2025-12-31T23:59:59.999Z",
  createdAt: "2024-12-01T12:00:00.000Z",
  createdBy: "admin@swarapoint.com",
  updatedAt: "2025-01-15T10:30:00.000Z",
  updatedBy: "manager@swarapoint.com",
  provider: "manual",
};

